import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';

@Component({
	selector: 'app-status-header',
	standalone: false,
	templateUrl: './status-header.component.html',
	styleUrls: ['./status-header.component.scss'],
})
export class StatusHeaderComponent {
	@Input() showBackBtn: boolean = false;
	@Input() showLangWithAddress: boolean = false;
	@Input() showLang: boolean = false;
	@Input() transparent: boolean = false;
	@Input() showCenteredSingleLogo = false;

	@Output() back = new EventEmitter<void>();

	private repositoryService = inject(RepositoryService);
	address: string = this.repositoryService.venue?.address ?? '';

	onBackClick() {
		this.back.emit();
	}

	onLangClick() {}
}
